
/**
 * DB SERVICE (DEPRECATED)
 * 
 * Database requirements have been removed. 
 * User session data is handled strictly via Joisst API.
 */
export const UserService = {
  getAllUsers: async () => [],
  // Fixed: Added parameters to updateUser to match usage in Admin.tsx (Expected 0 arguments, but got 2)
  updateUser: async (userId: string, updates: any) => null,
};
